import type { BusinessExpenseCategoryYoYRow, ExpenseByCategoryRow } from '../../types/report.types';
import { sanitiseBusinessCategoryDisplayName } from './business-expense-merchant';

export function buildBusinessExpenseCategoryYearOnYear(
  currentByCategory: ExpenseByCategoryRow[],
  priorByCategory: ExpenseByCategoryRow[],
  priorPeriodHasData: boolean
): BusinessExpenseCategoryYoYRow[] {
  if (!priorPeriodHasData) return [];

  const priorMap = new Map(
    priorByCategory.map((r) => [sanitiseBusinessCategoryDisplayName(r.categoryName), r.amount])
  );

  return currentByCategory
    .map((row) => {
      const name = sanitiseBusinessCategoryDisplayName(row.categoryName);
      const priorAmountAud = priorMap.get(name) ?? 0;
      const changeAud = row.amount - priorAmountAud;
      const changePercent =
        priorAmountAud > 0 ? (changeAud / priorAmountAud) * 100 : row.amount > 0 ? null : 0;
      return {
        categoryName: name,
        currentAmountAud: row.amount,
        priorAmountAud,
        changeAud,
        changePercent,
      };
    })
    .sort((a, b) => b.currentAmountAud - a.currentAmountAud);
}
